import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  Paper,
  Skeleton,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GetAppIcon from "@mui/icons-material/GetApp";
import { ReactComponent as CSVIcon } from "./../../../assets/icons/csvIcon.svg";
import { useEffect, useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../context/global";
import { toast } from "react-toastify";
import { encodeData } from "../../../helper/common/encodeData";
import DataNotFound from "../../DataNotFound/DataNotFound";
import { ALL_INTEGRATION_UPLOAD_TYPE_OPTIONS, DEFAULT_SELECTED_UPLOAD_TYPE, UPLOAD_TYPE_FILTER_MAPPING } from "../../../helper/channelIntegrattion/integrationData";

export default function HistoryModal({ open, onClose, jobType }) {
  const [isLoading, setIsLoading] = useState(false);
  const { clientId } = useGlobalContext();
  const [rows, setRows] = useState([]);

  const [selectedUploadType, setSelectedUploadType] = useState(DEFAULT_SELECTED_UPLOAD_TYPE[jobType]);
  const UPLOAD_TYPE_OPTIONS = ALL_INTEGRATION_UPLOAD_TYPE_OPTIONS[jobType]


  // Convert API response -> frontend rows
 const convertAPIResToFrontendFriendly = (apiResponse = []) => {
  const actionMap = {
    OVER_WRITE: "Uploaded",
    WRITE_APPEND: "Updated",
  };

  return apiResponse.map((item) => {
    let extra = {};

    try {
      if (item.extra_info_json) {
        extra = JSON.parse(item.extra_info_json);
      }
    } catch (e) {
      console.warn("Invalid extra_info_json:", e);
    }

    let formattedDate = "-";
    if (extra.date) {
      try {
        const dateObj = new Date(extra.date);
        formattedDate = dateObj.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "2-digit",
        });
      } catch {
        formattedDate = "-";
      }
    }

    const productCount = extra.product_count
      ? `${extra.product_count} Products`
      : "-";
    const action =
      actionMap[extra.upload_action] || extra.upload_action || "-";

    return {
      date: formattedDate,
      fileName: extra.csv_file_name || "-",
      productCount,
      productsText: productCount,
      action,
      user: extra.username || "-",
      csvUrl: extra.csv_url || "-",
      status: item.status || "-",
      jobType: item.job_type || "-",
    };
  });
};


  useEffect(() => {
    if (!open) return;
    setIsLoading(true);
    let filtering = [...UPLOAD_TYPE_FILTER_MAPPING[selectedUploadType]];
    axios
      .get(
        `${
          process.env.REACT_APP_ADS_API
        }/clients/${clientId}/job-tracking?filtering=${encodeData(filtering)}&order_by=updated_at&sorting_order=desc`
      )
      .then((res) => {

        let consolidatedData = convertAPIResToFrontendFriendly(res.data.data);
        setRows((prev) => {
          return [...consolidatedData];
        });
      })
      .catch((err) => {
        toast.error("Unable to fetch history data. Please try again!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [open,selectedUploadType]);

  const commonCellStyle = (isActive, bgColor = "#F7F6FE") => ({
    background: isActive ? bgColor : "#ffffff",
    fontWeight: 600,
    fontSize: "0.75rem !important",
    whiteSpace: "nowrap",
    padding: "8px 16px",
    // borderRight: "1px solid #ddd",
    // minWidth: 120,
    textAlign: "center",
  });

  return (
    <Modal
      open={!!open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 900,
          //   maxHeight:"700px",
          overflow: "auto",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
        }}
      >
        {/* Modal Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          px={2.5}
          pt={2.5}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="subtitle1" color="text.primary">
              {[
                "FK_STATS_CSV_SYNC",
                "MYNTRA_STATS_CSV_SYNC",
                "AMAZON_STATS_CSV_SYNC",
              ].includes(jobType)
                ? "Upload History For Order Data"
                : "Upload History For"}
            </Typography>
            {[
              "FK_STATS_CSV_SYNC",
              "MYNTRA_STATS_CSV_SYNC",
              "AMAZON_STATS_CSV_SYNC",
            ].includes(jobType) ? null : (
              <Select
                size="small"
                value={selectedUploadType}
                onChange={(e) => setSelectedUploadType(e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                  const option = UPLOAD_TYPE_OPTIONS.find(
                    (o) => o.value === selected
                  );
                  return option ? option.label : "Select";
                }}
                sx={{
                  height: "36px",
                  minWidth: 140,
                  fontSize: "12px",
                  color: "#333333",
                  textTransform: "none",
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#333333",
                    padding: "6px 12px",
                    minHeight: "36px",
                  },
                  "& svg": {
                    color: "#333333",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "grey.300",
                  },
                }}
                MenuProps={{
                  disableScrollLock: true,
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                      mt: 1,
                      "& .MuiMenuItem-root": {
                        fontSize: "14px",
                        color: "#333333",
                        minHeight: "36px",
                        padding: "6px 12px",
                        "&.Mui-selected": {
                          backgroundColor: "grey.100 !important", // override theme
                          color: "#333333 !important", // force text color
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "grey.100 !important",
                          color: "#333333 !important",
                        },
                        "&:hover": {
                          backgroundColor: "grey.50",
                        },
                      },
                      "& .MuiList-root": {
                        paddingTop: 0,
                        paddingBottom: 0,
                      },
                    },
                  },
                  MenuListProps: {
                    sx: {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  },
                }}
              >
                {UPLOAD_TYPE_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ background: "#E0E0E0" }} />

        <Box
          maxHeight={500}
          display="flex"
          flexDirection="column"
          gap={1}
          p={2.5}
          mb={4}
        >
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              maxHeight: 500,
              overflow: "auto",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "none",
              marginTop: 1,
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...commonCellStyle(), top: 0, zIndex: 2 }}>
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      ...commonCellStyle(),
                      top: 0,
                      zIndex: 2,
                      minWidth: "220px",
                    }}
                  >
                    CSV File
                  </TableCell>
                  <TableCell sx={{ ...commonCellStyle(), top: 0, zIndex: 2 }}>
                    Product Count
                  </TableCell>
                  <TableCell sx={{ ...commonCellStyle(), top: 0, zIndex: 2 }}>
                    Upload Action
                  </TableCell>
                  <TableCell sx={{ ...commonCellStyle(), top: 0, zIndex: 2 }}>
                    User
                  </TableCell>
                  <TableCell
                    sx={{
                      ...commonCellStyle(),
                      width: "30px",
                      top: 0,
                      zIndex: 2,
                    }}
                  />
                </TableRow>
              </TableHead>

              <TableBody>
                {isLoading ? (
                  [...Array(10)].map((_, idx) => (
                    <TableRow key={idx}>
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Skeleton width={60} />
                      </TableCell>
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Skeleton
                            variant="rectangular"
                            width={28}
                            height={28}
                            sx={{ borderRadius: "4px" }}
                          />
                          <Box>
                            <Skeleton width={100} />
                            <Skeleton width={60} />
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Skeleton width={80} />
                      </TableCell>
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Skeleton width={100} />
                      </TableCell>
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Skeleton width={140} />
                      </TableCell>
                      <TableCell
                        sx={{ ...commonCellStyle(), width: "30px" }}
                        align="right"
                      >
                        <Skeleton variant="circular" width={20} height={20} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : rows.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={{ ...commonCellStyle(), height: "400px" }}
                    >
                      <DataNotFound />
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, idx) => (
                    <TableRow key={idx} hover>
                      {/* Date */}
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Typography variant="caption">{row.date}</Typography>
                      </TableCell>

                      {/* CSV File */}
                      <TableCell
                        sx={{
                          ...commonCellStyle(),
                          minWidth: "220px",
                          textAlign: "left",
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <CSVIcon />
                          <Box>
                            <Tooltip
                              title={
                                row.fileName.length > 20 ? row.fileName : ""
                              }
                              arrow
                            >
                              <Typography
                                variant="caption"
                                fontWeight={500}
                                noWrap
                                sx={{
                                  maxWidth: 180,
                                  display: "inline-block",
                                }}
                              >
                                {row.fileName}
                              </Typography>
                            </Tooltip>

                            {/* <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", textAlign: "left" }}
                              >
                                {row.productsText}
                              </Typography> */}
                          </Box>
                        </Box>
                      </TableCell>

                      {/* Product Count */}
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Typography variant="caption">
                          {row.productCount}
                        </Typography>
                      </TableCell>

                      {/* Upload Action */}
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Typography variant="caption">{row.action}</Typography>
                      </TableCell>

                      {/* User */}
                      <TableCell sx={{ ...commonCellStyle() }}>
                        <Typography variant="caption">{row.user}</Typography>
                      </TableCell>

                      {/* Download icon */}
                      <TableCell
                        sx={{ ...commonCellStyle(), width: "30px" }}
                        align="right"
                      >
                        {row.csvUrl && idx === 0 && (
                          <IconButton
                            size="small"
                            color="primary"
                            component="a"
                            href={row.csvUrl}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <GetAppIcon fontSize="small" />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Modal>
  );
}